export const radioOptions = () => {
  return [
    { key: 'ΝΑΙ', value: true },
    { key: 'ΟΧΙ', value: false },
  ];
};

export const markerRadioOptions = () => {
  return [
    { key: 'Ορατό στο κοινό', value: 'visible' },
    { key: 'Ενδεικτικό', value: 'sample' },
    { key: 'Μη ορατό στο κοινό', value: 'hidden' },
  ];
};